export default __webpack_public_path__ + "static/media/formLevelDownIcon.41aba490.svg";